export interface MetaProps {
  'X-Dasl-Session-ID': string;
}

export class ApiError extends Error {
  constructor(public sessionId: string, message?: string) {
    super(message);
    // removing unnecessary stack
    this.stack = '';
  }
}
